export default {
  'form.error.required': 'Required field',
  'form.error.safeDisplayText':
    'Use only letters (including accents), numbers, spaces, and these characters: {allowedChars}.',
  'form.error.question.required': 'You must select at least one answer for each question',
  'form.error.email': 'You must enter a valid email address.',
  'form.error.url': 'You must enter a valid URL',
  'form.error.password.check': 'The password is not valid',
  'form.error.password.match': 'Passwords do not match',
  'form.error.file.allowedFormat': '{fileName} is not an allowed file.',
  'form.error.file.allowedFormats': '{fileName} are not allowed files.',
  'form.error.file.duplicated': 'The file "{fileName}" already exists.',
  'dynamicFieldsList.duplicateItem': 'This item has already been added.',
  'form.error.file.maxSize': 'File size exceeds maximum allowed.',
  'form.error.files.maxSize': 'Files size exceeds field maximum allowed.',
  'form.error.empty': ' ',
  'form.error.table.required': 'Row Number {rowNumber}',
  'form.error.fieldsValidationError': `The form contains validation errors. Please review the highlighted fields and submit again.`,
  'form.error.offline': "You're offline! The form data will be saved in the local store.",
  'form.error.offline2': "You're offline! The form cannot be sent.",
  'form.help.online': "You're back online! Go ahead and send the form.",
  'form.help.online2': "You're back online! The saved form data will be sent now.",
  'form.help.maxFileSize': 'Please upload a file that does not exceed {maxFileSize}',
  'form.help.maxFilesSize': 'Please upload files that does not exceed field limit {maxFileSize}',
  'form.error.file.upload': 'Upload failed for "{fileName}"',
  'form.error.file.remove': 'Removal failed for "{fileName}"',
  'form.error.file.parse': 'Failed to parse "{fileName}"',

  'input.validation.regexp': "The value doesn't match the regular expression {regexp}.",
  'input.validation.url': 'The value is not a valid link.',
  'input.validation.uuid': 'The value is not a valid UUID.',
  'input.validation.numeric': 'Only numeric values are allowed',
  'input.validation.integer': 'Decimal values are not allowed for integer fields',
};
